import { Component, Inject, OnInit } from '@angular/core';
import { ContendientesService } from '../../services/contendientes.service';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-visor',
  templateUrl: './visor.component.html',
  styleUrls: ['./visor.component.css'],
})
export class VisorComponent implements OnInit {
  Oid = '';
  Tipo = 1;
  parametrosCorrectos = true;
  sinDocumento = false;
  Documento = '';
  diputado: any;

  Archivo: string = '';
  lectorPdf: boolean = false;
  pdfCarga: boolean = true;
  pdfError: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<VisorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ContendientesService,
    private url: ActivatedRoute
  ) {}

  ngOnInit(): void {
      let _tipo = this.data.tipo;
      this.Oid = this.data.oid;
      this.Tipo = parseInt(_tipo, 10);
      if (
        typeof this.Tipo === 'number' &&
        Number.isInteger(this.Tipo) &&
        this.esUUID(this.Oid)
      )
        this.getDetalleOid();
      else this.parametrosCorrectos = false;
  }
  esUUID(valor: string) {
    const uuidRegex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89ABab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(valor);
  }
  getDetalleOid() {
    this.api.getDocContendiente(false, this.Oid).subscribe((data) => {
      this.diputado = data;
      //Carta
      if (this.Tipo == 1) {
        this.Documento = 'Carta';
        if (this.diputado.ArchivoB64 == null) this.sinDocumento = true;
        else
          this.Archivo =
            `data:application/pdf;base64,` + this.diputado.ArchivoB64;
      }
      //Renuncia de Apoyo
      if (this.Tipo == 2) {
        this.Documento = 'Renuncia de Apoyo';
        if (this.diputado.SFTPDocumento1 == null) this.sinDocumento = true;
        else this.Archivo = this.diputado.SFTPDocumento1;
      }
    });
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }
}
